<template>
    <span
        class="spinner"
        :style="spinnerStyle"
        role="status"
        aria-live="polite"
    >
        <span class="sr-only">Loading</span>
    </span>
</template>

<script>
const sizePresets = {
    small: 16,
    medium: 28,
    large: 40,
};

export default {
    name: 'Spinner',
    props: {
        size: {
            type: [Number, String],
            default: 'medium',
        },
        lineSize: {
            type: Number,
            default: 3,
        },
        lineBgColor: {
            type: String,
            default: '#f3f3f3',
        },
        lineFgColor: {
            type: String,
            default: '#555',
        },
		speed: { type: Number, default: 0.8 },
    },
    computed: {
        diameter() {
            if (typeof this.size === 'number') {
                return this.size;
            }

            const preset = sizePresets[this.size];
            if (preset) {
                return preset;
            }

            const parsed = parseInt(this.size, 10);
            return Number.isNaN(parsed) ? sizePresets.medium : parsed;
        },
		spinnerStyle() {
			const borderWidth = `${this.lineSize}px`;
			return {
				width: `${this.diameter}px`,
				height: `${this.diameter}px`,
				borderWidth,
				borderStyle: 'solid',
				borderTopColor: this.lineFgColor,
				borderRightColor: this.lineBgColor,
				borderBottomColor: this.lineBgColor,
				borderLeftColor: this.lineBgColor,
				animation: `spinner-rotate ${this.speed}s linear infinite`,
			};
		}
    },
};
</script>

<style>
.spinner {
    display: inline-block;
    border-style: solid;
    border-radius: 50%;
}

.sr-only {
    position: absolute;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
    white-space: nowrap;
}

@keyframes spinner-rotate {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
